import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Autoplay } from "swiper/modules";
import { useSearch } from "../../context/SearchContext";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import Swal from 'sweetalert2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import API_BASE_URL from '../../config.js';
import getBanners from '../../services/getBanners';
import getCities from "../../services/getCities";

import bienvenida from "../../assets/bienvenida.png";
import Cancelar from "../../assets/Cancelar.png";
import destino from "../../assets/Destino.png";
import fechas from "../../assets/Llegada salida.png";
import huespedes from "../../assets/Huespedes.png";
import iconLetoh from "../../assets/iconLetoh.png"

import './Searcher.css';

const Searcher = () => {

    const { city, setCity, checkIn, setCheckIn, checkOut, setCheckOut, guests, setGuests, setTag, setTags, loading, setLoading } = useSearch();
    const [banners, setBanners] = useState([]);
    const [cities, setCities] = useState([]);
    const [resultCities, setResultCities] = useState({});
    const [dateRange, setDateRange] = useState([null, null]);
    const [start_Date, end_Date] = dateRange || ["", ""];
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [openCalendar, setOpenCalendar] = useState(false);
    const [loadingImg, setLoadingImg] = useState(true);
    const BASE_URL = API_BASE_URL.slice(0, -4);
    const navigate = useNavigate();

    const handleCities = (city) => {
        setCity(city)
        const filterTags = resultCities?.cities[city] || []
        setTags(filterTags)
        setTag("")
    }

    const handleDateChange = (update) => {
        setDateRange(update);
        if (update[0] && update[1]) {
            const checkInDate = update[0].toISOString().split("T")[0];
            const checkOutDate = update[1].toISOString().split("T")[0];
            setCheckIn(checkInDate);
            setCheckOut(checkOutDate);
            setOpenCalendar(false);
        }
    };

    const handleValidation = () => {
        if (!city) {
            Swal.fire({
                imageUrl: Cancelar,
                imageWidth: 80,
                imageHeight: 80,
                title: 'Destino requerido',
                text: 'Por favor, selecciona un destino.',
                timer: 5000,
                timerProgressBar: true,
                showConfirmButton: true,
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#1F4F51',
                customClass: {
                    confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",

                },
            });
            return false;
        }
        // if (!start_Date || !end_Date) {
        //     Swal.fire({
        //         imageUrl: Cancelar,
        //         imageWidth: 80,
        //         imageHeight: 80,
        //         title: 'Fechas requeridas',
        //         text: 'Por favor, selecciona las fechas de llegada y salida.',
        //         timer: 5000,
        //         timerProgressBar: true,
        //         showConfirmButton: true,
        //         confirmButtonText: 'Entendido',
        //         confirmButtonColor: '#1F4F51',
        //         customClass: {
        //             confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",

        //         },
        //     });
        //     return false;
        // }
        // if (end_Date < start_Date) {
        //     Swal.fire({
        //         imageUrl: Cancelar,
        //         imageWidth: 80,
        //         imageHeight: 80,
        //         title: 'Fechas inválidas',
        //         text: 'La fecha de salida no puede ser anterior a la de llegada.',
        //         timer: 5000,
        //         timerProgressBar: true,
        //         showConfirmButton: true,
        //         confirmButtonText: 'Entendido',
        //         confirmButtonColor: '#1F4F51',
        //         customClass: {
        //             confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",
        //         }
        //     });
        //     return false;
        // }
        // if (end_Date.getTime() == start_Date.getTime()) {
        //     Swal.fire({
        //         imageUrl: Cancelar,
        //         imageWidth: 80,
        //         imageHeight: 80,
        //         title: 'Fechas inválidas',
        //         text: 'La fecha de salida no puede ser igual a la de llegada.',
        //         timer: 5000,
        //         timerProgressBar: true,
        //         showConfirmButton: true,
        //         confirmButtonText: 'Entendido',
        //         confirmButtonColor: '#1F4F51',
        //         customClass: {
        //             confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",
        //         }
        //     });
        //     return false;
        // }
        if (!guests) {
            Swal.fire({
                imageUrl: Cancelar,
                imageWidth: 80,
                imageHeight: 80,
                title: 'Número de huéspedes',
                text: 'Por favor, selecciona el número de huéspedes.',
                timer: 5000,
                timerProgressBar: true,
                showConfirmButton: true,
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#1F4F51',
                customClass: {
                    confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",

                },
            });
            return false;
        }
        return true;
    };

    const handleClick = () => {
        if (handleValidation()) {
            try {
                navigate(
                    `/listings?city=${encodeURIComponent(city)}&checkIn=${encodeURIComponent(checkIn)}&checkOut=${encodeURIComponent(checkOut)}&guests=${encodeURIComponent(guests)}`
                );
            } catch (error) {
                console.error("Error obteniendo los resultados:", error);
            }
        }
    };
    const handleImageLoading = (isLoading) => {
        setLoadingImg(isLoading);
    };
    useEffect(() => {
        const loadData = async () => {
            setLoading(true)

            try {
                const fetchCities = async () => {
                    const responseCities = await getCities();
                    setResultCities(responseCities)
                    setCities(Object.keys(responseCities.cities));
                }
                const fetchBanners = async () => {
                    const responseBanners = await getBanners();
                    setBanners(responseBanners);
                };
                fetchBanners();
                fetchCities();
                const handleResize = () => setIsMobile(window.innerWidth < 768);
                window.addEventListener("resize", handleResize);

                return () => window.removeEventListener("resize", handleResize);

            } catch (error) {
                console.error("Error cargando datos:", error);
            } finally {
                setLoading(false)
            }
        };
        loadData();
    }, []);

    return (
        <div className="relative w-full h-[500px] font-poppins">
            {(loading || loadingImg) && (<div className="fixed inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center z-50">
                <img src={iconLetoh} alt="Icono Letoh" className="w-20 h-20 mb-4 animate-pulse" />
            </div>)}
            <Swiper
                modules={[Autoplay]}
                autoplay={{ delay: 8000, disableOnInteraction: false }}
                loop={true}
                className="absolute inset-0 w-full h-full z-10"
            >
                {banners.map((banner, index) => (
                    <SwiperSlide key={index}>
                        <div className="relative w-full h-full">
                            {/* {setLoadingImg(true)} */}
                            <img
                                alt={banner.description}
                                className="w-full h-full object-cover"
                                onError={() => handleImageLoading(false)}
                                src={`${BASE_URL}${isMobile ? banner.imagenMovil : banner.imagenDesktop}`}
                                onLoad={() => handleImageLoading(false)} />
                            <div className="absolute bottom-0 left-0 w-full h-40 bg-gradient-to-t from-white to-transparent"></div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            <div className="absolute inset-0 flex flex-col items-center justify-center z-20 px-4 mt-6 md:mt-10">
                <img
                    src={bienvenida}
                    alt=""
                    className="w-60 h-[70px] md:w-[450px] md:h-[130px]"
                />
                <div className="bg-white px-6 rounded-3xl shadow-lg max-w-md w-full mx-4 mt-4">

                    <div className="flex-1 flex justify-center items-center border-b border-gray-300 py-3">
                        <img src={destino} alt="" className="h-6 mr-2" />
                        <select
                            value={city}
                            onChange={(e) => handleCities(e.target.value)}
                            className="border-none text-lg text-center"
                        >
                            <option value="" disabled hidden >Destino</option>
                            {cities.map((city, index) => (
                                <option key={index} value={city}>
                                    {city}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="flex items-center p-3 ">
                        <img src={fechas} className="h-6 md:mr-3" />
                        <DatePicker
                            selected={start_Date}
                            onChange={(update) => handleDateChange(update)}
                            startDate={start_Date}
                            endDate={end_Date}
                            selectsRange
                            shouldCloseOnSelect={true}
                            open={openCalendar}
                            onClickOutside={() => setOpenCalendar(false)}
                            onFocus={() => setOpenCalendar(true)}
                            minDate={new Date()}
                            placeholderText="Llegada / salida"
                            className=" border-none text-lg text-center p-0"
                        />

                    </div>

                    <div className="flex justify-center items-center py-3 border-t border-gray-300">
                        <img src={huespedes} className="h-6" />
                        <select
                            value={guests}
                            onChange={(e) => setGuests(e.target.value)}
                            className=" border-none text-lg text-center"
                        >
                            {[...Array(15)].map((_, i) => (
                                <option key={i} value={i + 1} >
                                    {i + 1} Huésped{i > 0 ? "es" : ""}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <button
                    onClick={handleClick}
                    className="bg-[#1F4F51] w-40 h-[45px] text-white font-bold rounded-md  hover:bg-[#17403F] transition mt-4"
                >
                    Buscar
                </button>
            </div>
        </div>
    );
};

export default Searcher;
